import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function MyPortfolio() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    
    if (user && user.portfolio_slug) {
      // Rediriger directement vers le portfolio (fonctionne sur mobile et PC)
      navigate(`/portfolio/${user.portfolio_slug}`);
    } else if (user && !user.portfolio_slug) {
      alert("Erreur: Portfolio non configuré. Veuillez vous reconnecter.");
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground">Ouverture de votre portfolio...</p>
    </div>
  );
}
